﻿/// <reference path="../../../Scripts/TypeScript/angularjs/angular.d.ts"/>

namespace Umbrella.TaskHandling.Overview {
    import TaskTypeCategory = Umbrella.Modules.Tasks.TaskTypeCategory;

    @Pipe('TaskHandling', 'isCaseFlowType')
    class IsCaseFlowTypeFilter {
        public transform(taskTypeCategory: TaskTypeCategory | string): boolean {
            if (!taskTypeCategory) return false;

            switch (taskTypeCategory.toString().toLowerCase()) {
                case 'caseflow':
                case '9':
                    return true;
                default:
                    return false;
            }
        }
    }
}
